import React from 'react';
import styles from './date-picker.module.scss';
import DatePicker from 'react-datepicker';
import { ErrorIcon } from '../../assets/svgs';

const DateInput = ({ label, onChange, value, error, variant, rightAlign }) => {
  const Container = ({ children }) => {
    return (
      <div>
        <p className={styles.datePickerHeader}>Select date</p>
        {children}
      </div>
    );
  };

  return (
    <div className={styles.datePicker}>
      <label>{label}</label>
      <DatePicker
        selected={value}
        onChange={(date) => onChange(date)}
        wrapperClassName={
          variant === 'blue'
            ? styles.datePickerInputBlue
            : styles.datePickerInputDef
        }
        popperClassName={[
          styles.datePickerPopper,
          rightAlign && styles.datePickerPopperRightAlign,
        ]}
        showPopperArrow={false}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        maxDate={new Date()}
        calendarContainer={Container}
        placeholderText="Select date"
        dateFormat="MMM dd, yyyy"
      />
      {error && (
        <p className={styles.datePickerError}>
          <ErrorIcon />
          {error}
        </p>
      )}
    </div>
  );
};

export default DateInput;
